import { IBaseConfirmModalParams } from 'src/types/common.type';
import EventBus from './event-bus';
import { EventBusName, IBaseEventPayload } from './event-bus.types';

export default class EVENT {
  static onShowModalConfirm(params: IBaseConfirmModalParams) {
    EventBus.getInstance().post<IBaseEventPayload<any>>({
      type: EventBusName.SHOW_MODAL_CONFIRM,
      payload: params,
    });
  }

  static onError(params: any) {
    EventBus.getInstance().post<IBaseEventPayload<any>>({
      type: EventBusName.ERROR,
      payload: params,
    });
  }

  static onShowModalProfile() {
    EventBus.getInstance().post<IBaseEventPayload<any>>({
      type: EventBusName.SHOW_MODAL_PROFILE,
      payload: '1',
    });
  }

  static onShowModalChangePassword() {
    EventBus.getInstance().post<IBaseEventPayload<any>>({
      type: EventBusName.SHOW_MODAL_CHANGE_PASSWORD,
      payload: '1',
    });
  }
}
